module.exports = __webpack_public_path__ + "officialStatic/img/productB33.3ef6adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB33.png
// module id = IybI
// module chunks = 0